<script setup>
import {
    ref,
    onMounted,
    onBeforeUnmount
} from 'vue';
import Sidebar from '@/components/layout/Sidebar.vue'
import Navbar from '@/components/layout/Navbar.vue'
import ContectPart from '@/components/layout/contectPart.vue'

const isMobile = ref(false)
const MOBILE_BREAKPOINT = 1024

// 移动端菜单显示状态
const mobileMenuVisible = ref(false)

// 检查屏幕宽度的函数
const checkScreenSize = () => {
    isMobile.value = window.innerWidth <= MOBILE_BREAKPOINT
}

// 监听窗口大小变化
const handleResize = () => {
    checkScreenSize()
    // 如果屏幕变大，自动关闭移动端菜单
    if (!isMobile.value) {
        mobileMenuVisible.value = false
    }
}

// 切换移动端菜单
const toggleMobileMenu = () => {
    mobileMenuVisible.value = !mobileMenuVisible.value
}

// 关闭移动端菜单
const closeMobileMenu = () => {
    mobileMenuVisible.value = false
}

onMounted(() => {
    checkScreenSize()
    window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize)
})
</script>

<template>
    <!-- <div v-if="!isMobile">
        <tipsComponets></tipsComponets>
    </div> -->
    <div class="app-wrapper">
        <Sidebar class="sidebar-container" :mobile-menu-visible="mobileMenuVisible" @close="closeMobileMenu" />
        <div class="main-container">
            <Navbar @toggle-mobile-menu="toggleMobileMenu" />
            <div class="main-content">
                <router-view />
            </div>
        </div>
        <div class="content-us">
            <ContectPart /> 
        </div>
    </div>
</template>

<style lang="less" scoped>
.app-wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    position: fixed;
}

.sidebar-container{
    width: 22rem;
}

.main-container {
    height: 100vh;
    flex-grow: 1;
    width: calc(100% - 22rem);
    overflow: auto;
    background: var(--main-background);
    
}
.main-content{
    padding: 10rem 3rem;
}

.content-us{
    display: none;
}
@media screen and (max-width: 512px) {
    .main-content{
        padding: 7rem 2rem;
    }
    
    .content-us{
        display: none;
    }
}
</style>